import React from "react";
import { Route } from "react-router-dom";
import dayjs from 'dayjs';
import { DATE_FORMAT } from "../variables/constants";
import APIService from '../services/apiservice';

export const NumberFormatter = (number, decimal=2) => {	
	return number !== undefined 
    ? parseFloat(number).toFixed(decimal).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : '';
};

export const FormatDateValue = (date) => {
	return date ? dayjs(date, DATE_FORMAT) : null;
}

export const handleTableChange = (doSearch, filters, filterName=null) => (pagination, tableFilters, sorter) => {
  const columnFilters = Object.fromEntries(
    Object.entries(tableFilters).map(([key, value]) => [
      key, 
      value ? value.join(', ') : '',
    ])
  );

  const sorting = sorter.field ? {
    sortby: sorter.field, 
    sortorder: sorter.order === 'descend' ? 'desc' : 'asc',
  } : {};

  const filterData = buildFilters({
		...filters,
		paginate: pagination.pageSize,
		page: pagination.current,
		...sorting,
		...columnFilters,
	});

	if(filterName){
		APIService.setPageFilters(filterName, filterData);
	}

  doSearch(filterData);
};

export const generateCRUDRoutes = ({
	mainTitle, 
	basePath, 
	mainComponent, 
	layout, 
	icon, 
	subTitle, 
	viewComponent, 
	createComponent, 
	editComponent,
	isMainMenu=true, 
	submodules=[],
	viewSubmodules=[],
	level=4,
	}) => {
		
	const pathSegments = basePath.split('/');	
	const recordId = `${pathSegments[pathSegments.length - 1].replace(/-/g, '').slice(0, -1)}Id`;
	return {
		name: `${mainTitle}`,
		path: `${basePath}`,
		component: mainComponent,
	    layout,	    
	    icon,	    
	    isMainMenu,
		level,
	    children: [
		  {
		    name: `${subTitle} Details`,
		    layout: layout,
		    path: `${basePath}/:${recordId}/view`,
		    component: viewComponent,
		    isMainMenu: false,
		    children: [
				...viewSubmodules,
			],
		  },
		  {
		    name: `Add ${subTitle}`,
		    layout: layout,
		    path: `${basePath}/add`,
		    component: createComponent,
		    isMainMenu: false,
		  },
		  {
		    name: `Edit ${subTitle}`,
		    layout: layout,
		    path: `${basePath}/:${recordId}/edit`,
		    component: editComponent,
		    isMainMenu: false,
		  },
		  ...submodules,
		]
	}
};

export const getRoutes = (routes, layout) => {
	return routes
	  .filter((route) => route.path !== "sign-in")
	  .map((prop, index) => {
		if (prop.layout === layout) {
		  return (			
			<React.Fragment key={`${prop.path}-${index}`}>
			  <Route path={prop.path.startsWith('/') ? prop.path : `/${prop.path}`} element={prop.component} />
			  {Array.isArray(prop.children) && getRoutes(prop.children, layout)}
			</React.Fragment>
		  );
		} else {
		  return null;
		}
	});
};

export const displayFullName = (data, lastNameFirst=true) => {	
	let fullName = '';
	if(lastNameFirst){
		fullName = data?.last_name && data?.last_name !== '' ? data?.last_name + ', ' : '';
		fullName += data?.first_name && data?.first_name !== '' ? data?.first_name + ' ' : '';
		fullName += data?.middle_name && data?.middle_name !== '' ? data?.middle_name : '';
	}else{		
		fullName = data?.first_name && data?.first_name !== '' ? data?.first_name+ ' ' : '';
		fullName += data?.middle_name && data?.middle_name !== '' ? data?.middle_name + ' ' : '';
		fullName += data?.last_name && data?.last_name !== '' ? data?.last_name : '';
	}
	return fullName.trim();
};

export const displayAddress = (address) => {
  if (!address) return '';

  const parts = [
    address.address_line1,
    address.address_line2,
    address.barangay,
    address.municipality,
    address.province,
    address.region,
  ].filter((part) => part && part.trim() !== '');

  return parts.join(', ');
};

export const displayFarmNameLocation = (farm) => {	
	if (!farm) return '';
	const parts = [
		farm.address?.barangay,
		farm.address?.municipality,
		farm.address?.province,
	].filter((part) => part && part.trim() !== '');

	return <>
				<strong>{farm.name}</strong>
				<br />
				{parts.join(', ')}
			</>
			  
};

export const renderLabel = (value) => <label className="ps-3 dark:text-white">{value || ''}</label>;

export const setAddressNameFields = (formData, regions, provinces, municipalities, barangays) => {
	const selectedRegion = regions.find(region => region.code === formData.address_region_code);
	formData.address_region = selectedRegion.name;

	const selectedProvince = provinces.find(province => province.code === formData.address_province_code);
	formData.address_province = selectedProvince ? selectedProvince.name : '';

	const selectedMunicipality = municipalities.find(municipality => municipality.code === formData.address_municipality_code);
	formData.address_municipality = selectedMunicipality.name;

	const selectedBarangay = barangays.find(barangay => barangay.code === formData.address_barangay_code);
	formData.address_barangay = selectedBarangay.name;

	return formData;
}

export const buildFilters = (values) => {
	return Object.fromEntries(
		Object.entries(values).filter(([_, value]) =>
		value !== null && value !== undefined && value !== ''
		)
	);
};